/* ==========================================================================
   Olfatto v2 — el color de familia en tactil

   El elemento signature del sistema ("el color solo existe en la
   interaccion") colgaba entero de :hover y :focus-visible. En un telefono
   no hay hover y el tap navega, asi que el momento que define el diseno no
   le ocurria nunca a la mayor parte del trafico, que llega de Instagram y
   TikTok. La tienda se veia blanca y generica: justo el riesgo que el
   sistema de diseno nombra.

   Aca la interaccion es el scroll. La fila que esta en el centro de la
   pantalla enciende su color y lo apaga al salir. Misma banda que
   olfatto-v2-sticky.js, para que las dos secciones se sientan iguales.

   Solo (hover: none). En desktop no se toca nada: alli el cursor ya apunta
   a una tarjeta y el disparador correcto sigue siendo el hover.

   Si esto falla, las tarjetas quedan monocromas: el estado actual, sin
   regresion. Ningun contenido depende de este script para leerse.
   ========================================================================== */
(function () {
  'use strict';

  if (!window.matchMedia('(hover: none)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        e.target.classList.toggle('is-near', e.isIntersecting);
      });
    },
    { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
  );

  function boot(scope) {
    (scope || document).querySelectorAll('.olf-card').forEach(function (c) {
      io.observe(c);
    });
  }

  if (document.readyState !== 'loading') boot();
  else
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });

  /* el editor de temas recarga secciones sin recargar la pagina */
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
